// extracted by mini-css-extract-plugin
export default {"container":"VariantList_container__YDG83","action":"VariantList_action__1CdLN","emptyWhite":"VariantList_emptyWhite__dLcpK"};